import { render, staticRenderFns } from "./aiLogin.vue?vue&type=template&id=57264760&scoped=true"
import script from "./aiLogin.vue?vue&type=script&lang=ts"
export * from "./aiLogin.vue?vue&type=script&lang=ts"
import style0 from "./aiLogin.vue?vue&type=style&index=0&id=57264760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57264760",
  null
  
)

export default component.exports